<template>
  <div>
    <div
      class="performance-summary-block profile-block rounded-5 position-relative"
      :class="positions ? '' : 'empty-custom-height'"
    >
      <div class="title color_text text-uppercase" v-if="positions">
        Performance Summary
      </div>

      <!-- SUMMARY DETAILS -->
      <div class="summary-details" v-if="positions">
        <div class="row">
          <div class="col-12 col-md-4">
            <!-- PERFORMANCE CHART -->
            <div class="performance-chart">
              <!-- PERFORMANCE CHART COMPONENT -->
              <PerformanceChart
                :average_score="Number(positions.studentAggregate)"
              ></PerformanceChart>
              <!-- PERFORMANCE CHART COMPONENT -->
            </div>

            <!-- CLASS RANK COMPONENT -->
            <ClassRank :ranking="positions"></ClassRank>
            <!-- CLASS RANK COMPONENT -->
          </div>

          <!-- PERFORMANCE TOPICS -->
          <div
            class="col-12 col-md-8 mt-4 mt-sm-4 mt-md-0 topics__block d-none d-md-block"
          >
            <div class="performance-topics">
              <!-- TOPIC BLOCK -->
              <div class="topic-block" v-if="excellence.length > 0">
                <div class="title color_grey_dark text-uppercase">
                  Excelling In
                </div>
                <!-- TOPIC BLOCK COMPONENT -->
                <div
                  class="d-flex justify-content-start align-items-start flex-wrap"
                >
                  <!-- IF TOPIC -->
                  <div
                    v-if="excellence.length > 0"
                    class="d-flex justify-content-start align-items-start flex-wrap"
                  >
                    <TopicBlock
                      :topic="topic.title"
                      status="excel"
                      v-for="(topic, index) in excellence"
                      :key="index"
                    ></TopicBlock>
                  </div>
                  <!-- IF NO TOPIC -->
                  <TopicBlock
                    v-else
                    :topic="message.excel"
                    status="excel"
                  ></TopicBlock>
                </div>
                <!-- TOPIC BLOCK COMPONENT -->
              </div>

              <!-- TOPIC BLOCK -->
              <div class="topic-block" v-if="average.length > 0">
                <div class="title color_grey_dark text-uppercase">
                  Average in
                </div>
                <!-- TOPIC BLOCK COMPONENT -->
                <div
                  class="d-flex justify-content-start align-items-start flex-wrap"
                >
                  <!-- IF TOPIC -->
                  <div
                    v-if="average.length > 0"
                    class="d-flex justify-content-start align-items-start flex-wrap"
                  >
                    <TopicBlock
                      :topic="topic.title"
                      status="average"
                      v-for="(topic, index) in average"
                      :key="index"
                    ></TopicBlock>
                  </div>
                  <!-- IF NO TOPIC -->
                  <TopicBlock
                    v-else
                    :topic="message.average"
                    status="average"
                  ></TopicBlock>
                </div>
              </div>
              <!-- TOPIC BLOCK COMPONENT -->

              <!-- TOPIC BLOCK -->
              <div class="topic-block" v-if="struggling.length > 0">
                <div class="title color_grey_dark text-uppercase">
                  Struggling With
                </div>
                <!-- TOPIC BLOCK COMPONENT -->
                <div
                  class="d-flex justify-content-start align-items-start flex-wrap"
                >
                  <!-- IF TOPIC -->
                  <div
                    v-if="struggling.length > 0"
                    class="d-flex justify-content-start align-items-start flex-wrap"
                  >
                    <TopicBlock
                      :topic="topic.title"
                      status="struggle"
                      v-for="(topic, index) in struggling"
                      :key="index"
                    ></TopicBlock>
                  </div>
                  <!-- IF NO TOPIC -->
                  <TopicBlock
                    v-else
                    :topic="message.struggle"
                    status="struggle"
                  ></TopicBlock>
                </div>
                <!-- TOPIC BLOCK COMPONENT -->
              </div>
            </div>
          </div>

          <!-- SHOW MORE BUTTON -->
          <div class="col-12 d-md-none">
            <div class="performance-dropdown text-center">
              <span
                class="text-uppercase color_grey_dark pointer see-more"
                @click="togglePerformanceTopics"
                >See More</span
              >
              <span
                class="text-uppercase color_grey_dark pointer see-less d-none"
                @click="togglePerformanceTopics"
                >See Less</span
              >
            </div>
          </div>
        </div>
      </div>

      <div
        class="empty-cover d-flex flex-column justify-content-center align-items-center"
        v-else
      >
        <img v-lazy="localImg('EmptyWork.png')" alt="EmptyAssessment" />
        <div class="text-content mt-3 text-center color_ash">
          You have no performance report for this subject. Take a diagnostic
          test to begin.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PerformanceChart from "@/components/profileComps/studentprofile/PerformanceChart";

export default {
  name: "PerformanceSummary",

  props: ["positions", "excellence", "average", "struggling"],

  components: {
    PerformanceChart,
    TopicBlock: () =>
      import(
        /* webpackChunkName: "PerformanceSummary" */
        "@/components/profileComps/studentprofile/TopicBlock"
      ),
    ClassRank: () =>
      import(
        /* webpackChunkName: "PerformanceSummary" */
        "@/components/profileComps/studentprofile/ClassRank"
      ),
  },

  data() {
    return {
      message: {
        excel:
          "This student is currently not excelling in any topic at the moment, please help this student improve!",
        average: "This student average subject topic list is currently empty",
        struggle:
          "This student is currently not struggling with any of this terms topics, topic list is empty",
      },
    };
  },

  computed: {
    getExcellenceList() {
      return this.performance ? this.performance.excellence : [];
    },

    getAverageList() {
      return this.performance ? this.performance.average : [];
    },

    getStrugglingList() {
      return this.performance ? this.performance.struggling : [];
    },
  },

  methods: {
    togglePerformanceTopics() {
      let topic_block = document.querySelector(".topics__block");
      let see_more = document.querySelector(".see-more");
      let see_less = document.querySelector(".see-less");

      topic_block.classList.toggle("d-none");
      see_more.classList.toggle("d-none");
      see_less.classList.toggle("d-none");
    },
  },
};
</script>

<style lang="scss">
.performance-summary-block {
  .title {
    @include breakpoint_max(sm) {
      font-size: 14px !important;
    }
    @include breakpoint_max(xs) {
      font-size: 13.5px !important;
    }
  }
  // PERFORMANCE TOPICS
  .performance-topics {
    padding-left: 30px;
    transition: all 0.3s ease-in-out;
    animation: panel-slide-down 0.5s ease-in-out forwards;

    @include breakpoint_max(lg) {
      padding-left: 20px;
    }

    @include breakpoint_max(md) {
      padding-left: 0px;
    }

    .topic-block {
      margin-bottom: 25px;

      @include breakpoint_max(sm) {
        margin-bottom: 15px;
      }
    }

    .title {
      font-size: 12px !important;
      line-height: 16px;
      letter-spacing: 0.02em;
      margin-bottom: 12px;

      @include breakpoint_max(sm) {
        font-size: 11.5px !important;
      }

      @include breakpoint_max(xs) {
        font-size: 11px !important;
      }
    }
  }

  .performance-dropdown {
    span {
      @include breakpoint_max(sm) {
        font-size: 12px !important;
      }
      @include breakpoint_max(xs) {
        font-size: 11px !important;
      }
    }
  }

  .empty-cover {
    background: rgba($brand_inverse_light, 0.7);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    .text-content {
      font-size: 17px;
      line-height: 33px;
      width: 75%;

      @include breakpoint_max(md) {
        font-size: 16px;
        line-height: 22px;
        width: 90%;
      }

      @include breakpoint_max(sm) {
        font-size: 13.25px;
      }
    }
  }
}

.empty-custom-height {
  height: 420px !important;
}
</style>
